import { SerializedError } from '@reduxjs/toolkit';
import {
  ErrorType,
  ReleaseErrorType,
} from 'services/api/responses/responseTypes';

const isExceptionCodeError = (error: unknown): error is SerializedError =>
  typeof error === 'object' && error != null && 'code' in error;

export const isReleaseLimitExceededError = (
  error: unknown
): error is SerializedError =>
  isExceptionCodeError(error) && error.code === ReleaseErrorType.LIMIT_EXCEEDED;

export const isReleaseError = (error: unknown): error is SerializedError =>
  isExceptionCodeError(error) &&
  (error.code === ReleaseErrorType.CATALOG_SONGS_CANNOT_BE_RELEASED ||
    error.code === ReleaseErrorType.SONG_TOO_SHORT ||
    error.code === ReleaseErrorType.ONLY_SONG_OWNER_CAN_RELEASE ||
    error.code === ReleaseErrorType.SONG_ALREADY_IN_RELEASE);

export const isCopyrightViolationError = (
  error: unknown
): error is SerializedError =>
  isExceptionCodeError(error) && error.code === ErrorType.COPYRIGHT_VIOLATION;

interface DownloadLimitError extends SerializedError {
  daysToReset: number;
}

export const isDownloadLimitError = (
  error: unknown
): error is DownloadLimitError =>
  isExceptionCodeError(error) &&
  error.code === ErrorType.DOWNLOAD_LIMIT_REACHED &&
  'daysToReset' in error;
